export default {
    'guest.activation.activating_message': 'Activating account, one moment please',
    'guest.activation.failure_message': 'Account Activation Failed. Account was not activated.',

    'guest.button.verification-resend': 'Resend Verification Email',
    'guest.button.login': 'Log in',
    'guest.button.reset_link': 'Send reset link',

    'guest.verification.message_title': 'We are almost there',
    'guest.verification.message_line1': 'Email is a very important part of how we help you to be the best version of yourself.',
    'guest.verification.message_line2': "That's why we sent you an email just to make sure we have the right one.",
    'guest.verification.message_line3': 'Please remember to add our email address to your contacts, that way we will not be placed in your spam folder.',
    'guest.verification.message_line4': "Speaking of SPAM folder, incase you don't see us in your inbox, remember to check there as well.",

    'message.activation.success': 'Your account was successfully activated!',
    'message.verification.resent': 'Your verification email was resent!',

    'message.password_reset': "Don't worry, just enter your email address below and we'll send you some instructions on how to get a new one.",
    'message.password_reset.success': 'Your password has been reset!',
    'message.reset_password_link': 'Password reset initiated. You should receive an email shortly with instructions on how to reset your password',

    'message.registration.server_error': "We're sorry, we're not able to create your free account at this moment, please try again or try back later.",
    'message.registration.user_error': 'Before we can create your free account, please make the corrections to the information you have entered below.',

    'message.login.server_error': "We're sorry, we're not able to log you in at this moment, please try again or try back later.",
    'message.login.user_error': 'Sorry! These credentials do not match our records.',

    'message.account_deactivated': 'Your Account has been deactivated.',

    'guest.login_link': 'Log in here',

    'guest.password_reset.remembered_password': 'Remembered your password?',

    'guest.registration.terms_conditions_statement': 'By continuing you agree to our Terms of Service and Privacy Policy',
    'guest.registration.terms_link': 'Terms of Service',
    'guest.registration.privacy_link': 'Privacy Policy',

    'guest.registration.fullname': 'Your Full Name',
    'guest.registration.username': 'Your Email Address',
    'guest.registration.email': 'Your Email Address',
    'guest.registration.password': 'Create Password',
    'guest.registration.confirm_password': 'Password Confirmation',
    'guest.registration.register_button': 'Create My Free Account',
    'guest.registration.continue_button': 'Confirm',
    'guest.registration.login': 'Looking to Login?',
    'guest.registration.show_password': 'Show Password',

    'guest.registration.social_login_title': 'Still hate Passwords?',
    'guest.registration.social_login_message': 'Quickly log in up using your favourite platform.',
    'guest.registration.social_login_promise': '(We will never post without asking)',

    'guest.verification.title': 'Verify Your Email Address',
    'guest.verification.sent_code_to': "We've sent a 6-digit code to",
    'guest.verification.verify_button': 'Verify Email',
    'guest.verification.didnt_receive': "Didn't receive a code?",
    'guest.verification.resend_link': 'Resend Code',
    'guest.verification.resend_sending': 'Sending...',
    'guest.verification.code_expires': 'Code expires in 30 minutes',
    'guest.verification.resend_success': 'A new verification code has been sent to your email.',
    'guest.verification.resend_failure': 'Failed to resend code. Please try again later.',
    'guest.verification.resend_wait': 'Resend code in {seconds}s',
    'guest.verification.generic_failure': 'Verification failed. Please try again.',
    'guest.verification.unexpected_error': 'An unexpected error occurred. Please try again.',

    'guest.countries': 'Countries',
    'guest.current_password': 'Current Password',
    'guest.deactivate_button': 'Deactivate',

    'guest.enable_button': 'Enable',
    'guest.forgot_password_button': 'Forgot Password?',

    'guest.incorrect_email_address': 'Email address entered does not match token.',

    'guest.login_button': "Let's go",

    'guest.login_to_app_heading': 'Login to HeadOffice Club',

    'guest.link.forgot_password': 'Forgot your password?',

    'guest.new_password': 'Your New Password',
    'guest.navigation_change_password': 'Change Password',
    'guest.navigation_deactivate_account': 'Deactivate Account',
    'guest.navigation_api_tokens': 'API Tokens',
    'guest.navigation_profile': 'Profile',
    'guest.navigation_two_factor_authentication': 'Two Factor Authentication',
    'guest.password': 'Password',
    'guest.password_confirmation': 'Confirm Password',
    'guest.password_new': 'New Password',
    'guest.register_heading': 'Looking to Register?',
    'guest.reset_password_heading': 'Reset Password',
    'guest.reset_password_button': 'Reset Password',
    'guest.send_reset_password_email_heading': 'Send Reset Password Email',
    'guest.send_email': 'Send Email',
    'guest.subscription_warning': 'This will also cancel your subscription',
    'guest.telephone_number': 'Telephone Number',
    'guest.update_password_button': 'Update Password',
};
